exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".moving-arrow {\n  border-right: 17px solid #f4f3ef;\n  border-top: 17px solid transparent;\n  border-bottom: 17px solid transparent;\n  display: inline-block;\n  position: absolute;\n  left: 243px;\n  top: 95px;\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1);\n}\n@media (max-width: 992px) {\n.moving-arrow {\n    display: none;\n}\n}\n", ""]);

// exports
